import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import exportTable from "../../../lib/exportTable";
import DownloadButton from "../../DownloadButton";

interface IProps {
  data: any;
}

const TableContainer: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const onExportTable = () => {
    const _data = _.cloneDeep(data).map((item: any) => {
      item.day = item.day ? moment(item.day).format('YYYY.MM.DD') : t('student.student.column47');
      return item;
    });
    const currentDate = moment(new Date());
    exportTable(columns, _data, `${t('statistics.web.1')}_(${currentDate.format('YYYYMMDD')})`, t('statistics.web.1'), [12, 10, 10]);
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('statistics.appday.column1'),
      dataIndex: 'day',
      key: 'day',
      align: 'center',
      render: value => value ? moment(value).format('YYYY.MM.DD') : t('student.student.column47'),
    },
    {
      title: t('student.student.option6'),
      dataIndex: 'parentCount',
      key: 'parentCount',
      align: 'center',
    },
    {
      title: t('common.menu.student'),
      dataIndex: 'studentCount',
      key: 'studentCount',
      align: 'center',
    },
  ];

  return (
    <>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: 1,
            pageSize: 999999999,
          }}
          rowClassName={(record: any) => record.day === null ? 'tfoot' : ''}
        />
      </div>
      <div className="comm-bx__space">
        <DownloadButton onClick={onExportTable} />
      </div>
    </>
  );
}

export default TableContainer;
